import { render, staticRenderFns } from "./ImportCodigosEstudiantes.vue?vue&type=template&id=2ede2db7&scoped=true"
import script from "./ImportCodigosEstudiantes.vue?vue&type=script&lang=js"
export * from "./ImportCodigosEstudiantes.vue?vue&type=script&lang=js"
import style0 from "./ImportCodigosEstudiantes.vue?vue&type=style&index=0&id=2ede2db7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede2db7",
  null
  
)

export default component.exports